<template>
  <b-container >
    <b-row>
      <b-col lg="5"><label class="text-sm-left" >{{label}}:</label></b-col>
      <b-col><b-form-checkbox
          :checked="in_value"
          :id="'input-' + var_name"
          v-model="in_value"
          :disabled="!editable"
          :state="validation_entry"
          @change="onChangedValue"
      ></b-form-checkbox></b-col>
    </b-row>
  </b-container>

</template>

<script>

import utils from '@/utils'

export default {
  props: {
    edit: Boolean,
    optional: Boolean,
    label: String,
    var_name: String,
    var_value: Boolean
  },
  data() {
    return {
      editable: this.edit || false,
      in_value: this.var_value,
      name: this.var_name
    }
  },
  computed: {
    validation_entry() {
      return this.optional || utils.isNotUndefined(this.in_value)
    }
  },
  methods: {
    onChangedValue () {
      this.$emit('onChangedValue', { name: this.var_name, value: this.in_value} )
    }
  },
  watch: {
    edit: function (newVal) { this.editable = newVal }
  },
}
</script>
